import { fork } from 'redux-saga/effects';

import { watcher as assignedGuardianListWatcher } from './assigned-guardian-list-req';
import { watcher as documentsCompletionWatcher } from './documents-completion-req';
import { watcher as assignmentWatcher } from './assignment-fetch-req';
import { watcher as documentsUploadWatcher } from './documents-upload-req';
import { watcher as documentsDeleteWatcher } from './documents-delete-req';
import { watcher as documentsListWatcher } from './documents-fetch-list-req';
import { watcher as personalInfoWatcher } from './personal-info-req';
import { watcher as generalInfoWatcher } from './general-info-req';
import { watcher as relationWatcher } from './relationship-req';
import progressRootSaga from './sagas';

export default function* root() {
  yield fork(assignedGuardianListWatcher);
  yield fork(personalInfoWatcher);
  yield fork(generalInfoWatcher);
  yield fork(documentsCompletionWatcher);
  yield fork(documentsListWatcher);
  yield fork(documentsUploadWatcher);
  yield fork(assignmentWatcher);
  yield fork(documentsDeleteWatcher);
  yield fork(relationWatcher);
  yield fork(progressRootSaga);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/root-saga.js